import Icon from 'components/shared/Icon/Icon';

const ImportedDataOverview = ({ overviewData, file }) => (
  <div className="flex w-full justify-center">
    <div className="w-full pt-8 text-left lg:px-4 md:px-4">
      <p className="text-lg font-500 text-primary-900">Imported data overview</p>
      <p className="text-sm text-neutral-500">
        Import overview data for
        <span className="font-semibold text-primary-800">{file.fileName}</span>
      </p>
      <p className="!mb-8 text-sm text-neutral-500">
        <span className="font-semibold text-primary-800">{file.fileType}</span> file type - duration
        of import
        <span className="font-semibold text-primary-800"> {file.duration}</span>
      </p>
      <div className="flex justify-between">
        <div className="flex flex-col items-start">
          <div className="flex items-center gap-1 text-neutral-500">
            <span className="block h-3 w-1 rounded-full bg-success-500"></span>
            Success
          </div>
          <div className="text-2xl font-semibold text-primary-900">{overviewData.success}</div>
        </div>
        <div className="flex flex-col items-start">
          <div className="flex items-center gap-1 text-neutral-500">
            <span className="block h-3 w-1 rounded-full bg-primary-300"></span>
            Expected
          </div>
          <div className="text-2xl font-semibold text-primary-900">{overviewData.expected}</div>
        </div>
        {/* <div className="flex flex-col items-start">
            <div className="flex items-center gap-1 text-neutral-500">
              <span className="block h-3 w-1 rounded-full bg-warning-500"></span>
              Duplicates
            </div>
            <div className="text-2xl font-semibold text-primary-900">{overviewData.duplicates}</div>
          </div> */}
        <div className="flex flex-col items-start">
          <div className="flex items-center gap-1 text-neutral-500">
            <span className="block h-3 w-1 rounded-full bg-warning-500"></span>
            Missing info
          </div>
          <div className="text-2xl font-semibold text-primary-900">{overviewData.missingInfo}</div>
        </div>
        <div className="flex flex-col items-start">
          <div className="flex items-center gap-1 text-neutral-500">
            <span className="block h-3 w-1 rounded-full bg-danger-500"></span>
            Failed
          </div>
          <div className="text-2xl font-semibold text-primary-900">{overviewData.failed}</div>
        </div>
      </div>

      <div className="mt-5 flex gap-4 rounded-md bg-primary-50 px-4 py-3">
        <Icon icon="comment-text-filled" color="primary" />
        Please prioritize patients with upcoming appointments.
      </div>
    </div>
  </div>
);

export default ImportedDataOverview;
